import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tableViewActive",
  "use": "tableViewActive-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"tableViewActive\">\n<path d=\"M0 6.5H18V11.5H0V6.5ZM18 5V2.75C18 1.234 16.7665 0 15.25 0H2.75C1.2335 0 0 1.234 0 2.75V5H18ZM0 13V15.25C0 16.766 1.2335 18 2.75 18H15.25C16.7665 18 18 16.766 18 15.25V13H0Z\" fill=\"#F2AE00\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol